import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { RealCostData } from "../../models/real-cost.model";
import { RealCostRepository } from "../../repositories/real-cost.repository";

interface LoadRealCostUseCaseParams {
  contractCode: string;
}

export class LoadRealCostUseCase
  implements UseCase<LoadRealCostUseCaseParams, RealCostData>
{
  constructor(private repo: RealCostRepository) {}
  execute(param: LoadRealCostUseCaseParams): Observable<RealCostData> {
    return this.repo.loadRealCost(param.contractCode);
  }
}

const retrieveRealCostUseCaseFactory = (repo: RealCostRepository) =>
  new LoadRealCostUseCase(repo);

export const retrieveRealCostUseCaseProvider: Provider = {
  provide: LoadRealCostUseCase,
  useFactory: retrieveRealCostUseCaseFactory,
  deps: [RealCostRepository],
};
